import { Component, OnInit, TemplateRef, ViewChild, ElementRef, HostListener } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { DeliveriesService } from 'src/app/services/api/deliveries.service';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EventsService } from '../../services/api/events.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppsettingsService } from '../../services/api/appsettings.service';
import { AuthService } from '../../services/api/auth.service';
import { MessagingService } from '../../services/api/messaging.service';
import { RatingService } from 'src/app/services/api/rating.service';
import { LocationStrategy } from '@angular/common';
import Swal from 'sweetalert2';
import { Subject, fromEvent, takeUntil } from 'rxjs';
import { DiscountService } from "src/app/services/api/discount.service";
import * as moment from "moment";
import { NavigationStart, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { DeviceDetectorService } from 'ngx-device-detector';


export let browserRefresh = false;
@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss']
})
export class AdminLayoutComponent implements OnInit {


  @ViewChild("inappmodal_rating") inappmodal_rating: TemplateRef<any>;
  @ViewChild("inappmodal_ads") inappmodal_ads: TemplateRef<any>;
  @ViewChild("inappmodal_announcement") inappmodal_announcement: TemplateRef<any>;
  @ViewChild("inappmodal_checkapp") inappmodal_checkapp: TemplateRef<any>;
  @HostListener('window:popstate', ['$event'])

  private unsubscriber: Subject<void> = new Subject<void>();
  subscription: Subscription;

  title = 'notification-push';
  message;
  buildOption: any = {
    build: "108",
    version: "1.10.22"
  }

  rateForm: FormGroup = new FormGroup({});
  rateIcon = 'assets/rate/rate05.svg';
  rateLabel = "Excellent Service!"
  rateIcons = [
    {
      id: 1,
      url: 'assets/rate/rate01.svg',
      active: 'assets/rate/rate01active.svg',
      inactive: 'assets/rate/rate01inactive.svg',
      label: 'The Worst!',
      value: 1,
      class: 'css-rate01'
    },
    {
      id: 2,
      url: 'assets/rate/rate02.svg',
      active: 'assets/rate/rate02active.svg',
      inactive: 'assets/rate/rate02inactive.svg',
      label: 'Needs Improvement',
      value: 2,
      class: 'css-rate02'
    },
    {
      id: 3,
      url: 'assets/rate/rate03.svg',
      active: 'assets/rate/rate03active.svg',
      inactive: 'assets/rate/rate03inactive.svg',
      label: 'Satsifactory',
      value: 3,
      class: 'css-rate03'
    },
    {
      id: 4,
      url: 'assets/rate/rate04.svg',
      active: 'assets/rate/rate04active.svg',
      inactive: 'assets/rate/rate04inactive.svg',
      label: 'Good Work!',
      value: 4,
      class: 'css-rate04'
    },
    {
      id: 5,
      url: 'assets/rate/rate05.svg',
      active: 'assets/rate/rate05active.svg',
      inactive: 'assets/rate/rate05inactive.svg',
      label: 'Excellent Service!',
      value: 5,
      class: 'css-rate05'
    }
  ]

  ratingScoreCard: any = [true, true, true, true, true]

  selectedRate: any = {
    id: 5,
    url: 'assets/rate/rate05.svg',
    label: 'Excellent Service!',
    value: 5,
    class: 'css-rate05'
  }

  delivery: any
  loadingRating: boolean = false
  filter: any = {};
  messageData: any = {}
  promoCodes: any = []
  images = []
  isMobile: boolean = false
  isMinimize: boolean = true

  constructor(private appsettingssrvc: AppsettingsService,
    private authsrvc: AuthService,
    private messagingService: MessagingService,
    public deliveryService: DeliveriesService,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    private elementRef: ElementRef,
    private fb: FormBuilder,
    private ratingsrvc: RatingService,
    private events: EventsService,
    private location: LocationStrategy,
    private discountSrvc: DiscountService,
    private router: Router,
    private deviceService: DeviceDetectorService) {

    this.messagingService.requestPermission()
    this.messagingService.receiveMessage()
    this.messagingService.subscribeToTopic()
    this.message = this.messagingService.currentMessage
    this.createDeviceObject()

    this.messagingService.getMessage()
      .subscribe((data) => {
        // console.log("getMessage", data)
        if (data["data"].type !== 'chatAlarm') {
          // console.log("data", data["data"])
          this.messageData = data["data"]
          console.log("this.messageData", this.messageData)

          if (data["data"].type == "multi") {
            if (data["data"].status === "last.completed") {
              this.rateUs(data["data"])
            }
          } else if (data["data"].type == "delivery") {
            if (data["data"].status === "completed") {
              this.rateUs(data["data"])
            }
          } else if (data["data"].type == "rental") {
            if (data["data"].status === "completed") {
              this.rateUs(data["data"])
            }
          }

          if (data["data"].status === "Push Notification") {
            this.showAnnouncement()
          }

          if (data["data"].type === "transaction") {
            this.removePackagestransactionStatus(this.messageData)
          }

          this.events.publishData({
            notification: true
          })
        }
      })

      this.events.getObservable().subscribe((data) => {
        console.log("getObservable", data)
        if (data.isMinimize) {
          this.isMinimize = data.isMinimize
          console.log("isMinimize", this.isMinimize)
        }
      });

    // setTimeout(() => {
    //   this.showAnnouncement()
    // }, 2000)

    // // console.log("window.location.href", window.location.href)
    // // history.pushState(null, null, window.location.href);
    // history.replaceState(null, null, '/login')
    // // history.back()
    // this.location.onPopState(() => {
    //   // history.pushState(null, null, window.location+'/login');
    //   history.replaceState(null, null, '/login')
    // });



    // history.pushState(null, '');
    // fromEvent(window, 'popstate').pipe(
    //   takeUntil(this.unsubscriber)
    // ).subscribe((_) => {
    //   history.pushState(null, '');
    // });

    // For Testing
    // setTimeout(() => {
    //   this.checkAds()
    // }, 2000)

    // this.subscription = router.events.subscribe((event) => {
    //   if (event instanceof NavigationStart) {
    //     browserRefresh = !router.navigated;
    //     // console.log("browserRefresh", browserRefresh)
    //   }
    // });


    this.isMobile = this.deviceService.isMobile();
    console.log("this.isMobile", this.isMobile)

  }


  ngOnInit(): void {
    this.filter.deliveryStatus = 'completed';
    this.getAppSetting()
    this.appVersionChecker()


    // history.pushState(null, '');
    // fromEvent(window, 'popstate').pipe(
    //   takeUntil(this.unsubscriber)
    // ).subscribe((_) => {
    //   history.pushState(null, '');
    // });

  }

  ngOnDestroy(): void {
    this.unsubscriber.next();
    this.unsubscriber.complete();
    // this.subscription.unsubscribe();
  }


  getAppSetting() {
    let token = localStorage.getItem('authToken')
    let group = JSON.parse(localStorage.getItem('USER_INFO'))
    // console.log("groupId", group);

    this.appsettingssrvc.getNewAppSettings(group.groupId, token).
      then(response => {
        // console.log("new settings", response);
      })
    this.getVouchers()
  }

  rateUs(item) {
    this.delivery = item
    // console.log("rateUs", this.delivery)
    this.modalService.open(this.inappmodal_rating, { centered: true, scrollable: true })
      .result.then(
        (result) => {
          // console.log("result", result);
          this.submitComment()
        }, (reason) => {
          // console.log("reason", reason);
        });
    // console.log("this.reateUs ", item)
  }

  submitComment() {
    // this.loaderSrvc.present('')
    this.loadingRating = true
    // console.log(this.rateForm.value)
    // console.log(this.selectedRate)
    let review
    review = {
      childId: this.delivery.childId,
      rate: this.selectedRate.value,
      comment: this.rateForm.value.comment,
      ratedUserId: this.delivery.sender,
      custom: {}
    }

    this.ratingsrvc.create(review)
      .subscribe(async res => {
        // this.loaderSrvc.dismiss()
        // console.log("ratingsrvc res", res)
        this.loadingRating = await false
      }, (err) => {
        // console.log(err)
        // this.loaderSrvc.dismiss()
      })
  }

  selectRate(info) {
    // console.log("info", info)
    this.rateIcon = info.url
    this.rateLabel = info.label
    this.selectedRate = info
    if (info.id >= 3) {
      let confettiSize = info.id == 3 ? 150 : info.id == 4 ? 250 : info.id == 5 ? 360 : 0
      // this.startConfetti(confettiSize)
    }

    if (info.id == 1) {
      this.ratingScoreCard = [true, false, false, false, false]
    } else if (info.id == 2) {
      this.ratingScoreCard = [true, true, false, false, false]
    } else if (info.id == 3) {
      this.ratingScoreCard = [true, true, true, false, false]
    } else if (info.id == 4) {
      this.ratingScoreCard = [true, true, true, true, false]
    } else if (info.id == 5) {
      this.ratingScoreCard = [true, true, true, true, true]
    }

  }

  appVersionChecker() {
    if (localStorage.getItem("AppVersion")) {
      let versionIs = JSON.parse(localStorage.getItem("AppVersion"))
      // console.log("versionIs", versionIs, versionIs.build, this.buildOption.build)
      if (Number(versionIs.build) < Number(this.buildOption.build)) {
        // console.log("need to update app")
        Swal.fire({
          title: 'Available Update',
          text: 'new update available version ' + this.buildOption.version,
          icon: 'info',
          confirmButtonText: 'Reload',
          customClass: 'swal-small',
          width: "30rem"
        }).then((result) => {
          localStorage.setItem("AppVersion", JSON.stringify(this.buildOption))
          window.location.reload()
        })
      }
    } else {
      localStorage.setItem("AppVersion", JSON.stringify(this.buildOption))
    }
  }

  createDeviceObject() {
    let deviceInfo
    deviceInfo = {
      deviceName: "Browser",
      deviceToken: "",
      deviceType: "web",
      type: "client", //this.user.type
      username: "", // this.user.username
    }
    localStorage.setItem("deviceInfo", JSON.stringify(deviceInfo))
  }

  checkAds() {
    this.modalService.open(this.inappmodal_ads, { centered: true, scrollable: false, size: "md" })
      .result.then(
        (result) => {
          console.log("result", result);
        }, (reason) => {
          // console.log("reason", reason);
        });
  }

  showAnnouncement() {
    console.log("hi o got called showAnnouncement")
    this.modalService.open(this.inappmodal_announcement, {
      size: "sm", centered: true, scrollable: false
    }).result.then((result) => {
      // console.log("result", result);
    }, (reason) => {
      // console.log("reason", reason);
    });

    setTimeout(() => {
      this.modalService.dismissAll()
      // console.log("close me")
    }, 60000)

  }

  async getVouchers() {
    //Get vouchers
    this.discountSrvc
      .getVouchers(localStorage.getItem("authToken"))
      .subscribe(async (res) => {
        let voucherList: any = []
        let getList: any = []
        await Object.keys(res).forEach(key => {
          voucherList.push(res[key])
        });
        voucherList.forEach((element) => {
          let check = moment(new Date()).isAfter(element.expiresAt);
          if (!check) {
            getList.push(element);
          }
        });
        let promoShow = getList
        let newList: any = []
        if (promoShow.length > 0) {
          promoShow.forEach(element => {
            if (element.type === "ads") {
              this.promoCodes.push(element)
            }
          });
          console.log("this.promoCodes"), this.promoCodes
          if (this.promoCodes.length > 0) {
            await this.checkAds()
          }
          // if (this.isMobile) {
          //   this.openOnApp()
          // } else {
          // if (this.promoCodes.length > 0) {
          //   await this.checkAds()
          // }
          // }


          // this.images = [
          //   {path: 'https://source.unsplash.com/800x600/?nature'},
          //   {path: 'https://source.unsplash.com/800x600/?car'},
          //   {path: 'https://source.unsplash.com/800x600/?moto'},
          //   {path: 'https://source.unsplash.com/800x600/?fantasy'},
          // ]
        }

      });
  }

  removePackagestransactionStatus(info) {
    // // console.log"121212", info);
    let packagestransactionStatus = [];

    if (localStorage.getItem("packagestransactionStatus") != null) {
      packagestransactionStatus = JSON.parse(
        localStorage.getItem("packagestransactionStatus")
      );
    }

    let obj = packagestransactionStatus.find(
      (o) => o.deliveryId === info.deliveryId.toUpperCase()
    );

    delete packagestransactionStatus[packagestransactionStatus.indexOf(obj)];

    packagestransactionStatus = packagestransactionStatus.filter(function (e) {
      return e != null;
    });
    localStorage.setItem(
      "packagestransactionStatus",
      JSON.stringify(packagestransactionStatus)
    );
  }

  openOnApp() {
    console.log("openOnApp")
    this.modalService.open(this.inappmodal_checkapp, { centered: true, scrollable: false, size: "md" })
      .result.then(
        (result) => {
          console.log("result", result);
          // const url = "intent://ionicdeeplink.cargaph.com/#Intent;scheme=cargashipper;package=carga.staging.io;end";
          // For android only
          const url = "intent://ionicdeeplink.cargaph.com/#Intent;scheme=cargashipper;package=carga.io;end";
          window.location.replace(url);
          this.modalService.dismissAll()
        }, (reason) => {
          // console.log("reason", reason);
        });


  }

}
